import azchestImage from '../Assets/images/azchest.png';
import aztraumaImage from '../Assets/images/aztrauma.png';
import azmeasureImage from '../Assets/images/azmeasure.png';
import azboneageImage from '../Assets/images/azboneage.png';
import noduleImage from '../Assets/images/nodule.png';

// Algorithm identifiers
export const ALGORITHMS = {
  AZCHEST: 'AZCHEST',
  AZTRAUMA: 'AZTRAUMA',
  AZMEASURE: 'AZMEASURE',
  AZBONEAGE: 'AZBONEAGE',
  AZNODE: 'AZNOD',
};

// Rayvolve (X-ray) product cards
export const ITEMS = [
  {
    id: 2,
    name: ALGORITHMS.AZTRAUMA,
    libelle: 'trauma',
    description:
      'Detecting fractures, dislocations, and joint effusions on X-rays',
    image: aztraumaImage,
    algo: ALGORITHMS.AZTRAUMA,
    certifs: ['CE', 'FDA'],
    otherCertifs: ['HSA', 'ANVISA', 'MDA', 'SFDA', 'TGA'],
  },
  {
    id: 1,
    name: ALGORITHMS.AZCHEST,
    libelle: 'chest',
    description:
      'Categorizes, detects and reports the main cardiac and lung abnormalities on X-rays',
    image: azchestImage,
    algo: ALGORITHMS.AZCHEST,
    certifs: ['CE', 'FDA'],
    otherCertifs: ['HSA', 'ANVISA', 'MDA', 'SFDA'],
  },
  {
    id: 3,
    name: ALGORITHMS.AZMEASURE,
    libelle: 'measure',
    description:
      'Automated characterization of osteo-articular geometries, including lengths and angular positions',
    image: azmeasureImage,
    algo: ALGORITHMS.AZMEASURE,
    certifs: ['CE'],
    excludeRegions: ['Brazil', 'USA'],
    otherCertifs: ['HSA', 'MDA'],
  },
  {
    id: 4,
    name: ALGORITHMS.AZBONEAGE,
    libelle: 'boneage',
    description:
      'Provides advanced automated calculation of the bone age of pediatric patients, based on the reference Greulich & Pyle methodology',
    image: azboneageImage,
    algo: ALGORITHMS.AZBONEAGE,
    certifs: ['CE'],
    excludeRegions: ['Brazil'],
    otherCertifs: [],
  },
];

// Rayscan (CT-scan) product cards
export const NODE_ITEMS = [
  {
    id: 1,
    name: ALGORITHMS.AZNODE,
    libelle: 'nod',
    description:
      'Detection and characterization of pulmonary nodules on chest CT scans',
    image: noduleImage,
    algo: ALGORITHMS.AZNODE,
    certifs: ['CE'],
    otherCertifs: [],
  },
];

// Background gradient of the AZNODE section title
export const AZNODE_BACKGROUND =
  'linear-gradient(to right, #ff4242ff ,#ff4242ff 1%, #ff424265 1%, #00000000 90%)';
